// Currency-view and scenario vocabulary for the /plan workspace pickers.
//
// Deliberately hand-written and NOT derived from the OpenAPI schema: neither
// is a wire shape. ``CurrencyView`` is a frontend composite of the two
// independent backend query params (``view`` × ``currency``), and the display
// labels are presentation copy. The scenario keys are also the page's own —
// the plan-grid endpoint spells the off-centre cases "good_case"/"bad_case",
// and call sites translate at the boundary.
//
// Sibling of plan-range.ts, which owns the window/period half of the same
// picker bar.

/** How forecast values are denominated: {booked|invoiced} × {contribution|revenue}. */
export type CurrencyView =
  | "booked_contribution"
  | "booked_revenue"
  | "invoiced_contribution"
  | "invoiced_revenue";

export const CURRENCY_VIEW_LABELS: Record<CurrencyView, string> = {
  booked_contribution: "Booked Contribution",
  booked_revenue: "Booked Revenue",
  invoiced_contribution: "Invoiced Contribution",
  invoiced_revenue: "Invoiced Revenue",
};

/** What-if multiplier applied to the algorithmic baseline only. */
export type ScenarioKind = "most_likely" | "good" | "bad";

export const SCENARIO_LABELS: Record<ScenarioKind, string> = {
  most_likely: "Most Likely",
  good: "Good",
  bad: "Bad",
};
